// import React, { useState } from 'react';
// import { MessageSquare, Send, Search, Filter, User, Clock, CheckCircle2, AlertCircle, Eye, Trash2, Reply, X, Building2 } from 'lucide-react';

// const AdminMessaging = () => {
//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [selectedMessage, setSelectedMessage] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [replyText, setReplyText] = useState('');

//   const messages = [
//     {
//       id: 1,
//       senderName: 'Dr. Fatou Ndiaye',
//       senderEmail: 'f.ndiaye@pharmacie.sn',
//       senderPhone: '+221 77 123 45 67',
//       pharmacy: 'Pharmacie Dakar Centre',
//       subject: 'Problème de connexion au système',
//       message: 'Bonjour, depuis ce matin je n\'arrive plus à me connecter à la plateforme. J\'obtiens une erreur "Session expirée" à chaque tentative. Pouvez-vous m\'aider ? Merci.',
//       status: 'pending',
//       priority: 'high',
//       timestamp: '2024-11-04T09:30:00',
//       replied: false,
//       reply: null
//     },
//     {
//       id: 2,
//       senderName: 'Dr. Amadou Diop',
//       senderEmail: 'a.diop@pharmacie.sn',
//       senderPhone: '+221 77 234 56 78',
//       pharmacy: 'Pharmacie Thies Nord',
//       subject: 'Demande d\'ajout de pharmacien',
//       message: 'Bonjour, j\'ai embauché un nouveau pharmacien, Dr. Mamadou Sall. Pourriez-vous créer son compte sur la plateforme ? Je vous envoie ses informations par email séparé. Merci d\'avance.',
//       status: 'in_progress',
//       priority: 'medium',
//       timestamp: '2024-11-04T08:15:00',
//       replied: false,
//       reply: null
//     },
//     {
//       id: 3,
//       senderName: 'Dr. Aïssa Fall',
//       senderEmail: 'a.fall@pharmacie.sn',
//       senderPhone: '+221 77 345 67 89',
//       pharmacy: 'Pharmacie Mbour',
//       subject: 'Question sur le planning de garde',
//       message: 'Bonjour, je voulais savoir comment modifier le planning de garde pour la semaine prochaine. Ma pharmacie ne pourra pas assurer la garde mercredi soir à cause de travaux. Merci.',
//       status: 'resolved',
//       priority: 'low',
//       timestamp: '2024-11-03T14:20:00',
//       replied: true,
//       reply: {
//         text: 'Bonjour Dr. Fall, vous pouvez modifier le planning directement depuis votre espace. Allez dans "Planning de garde" > Sélectionnez la semaine > Cliquez sur "Modifier". Si vous avez besoin d\'aide, n\'hésitez pas. Cordialement.',
//         timestamp: '2024-11-03T15:00:00',
//         repliedBy: 'Admin - Dr. Touré'
//       }
//     },
//     {
//       id: 4,
//       senderName: 'Dr. Moussa Sarr',
//       senderEmail: 'm.sarr@pharmacie.sn',
//       senderPhone: '+221 77 456 78 90',
//       pharmacy: 'Pharmacie Saint-Louis',
//       subject: 'Mise à jour des horaires',
//       message: 'Bonjour, suite à notre discussion téléphonique, je confirme que mes nouveaux horaires sont 7h30 - 21h30 du lundi au samedi. Pourriez-vous mettre à jour sur le système ? Merci beaucoup.',
//       status: 'resolved',
//       priority: 'low',
//       timestamp: '2024-11-03T11:45:00',
//       replied: true,
//       reply: {
//         text: 'Bonjour Dr. Sarr, vos horaires ont bien été mis à jour dans le système. Les patients pourront voir vos nouveaux horaires dès maintenant. Bonne continuation !',
//         timestamp: '2024-11-03T12:10:00',
//         repliedBy: 'Admin - Dr. Touré'
//       }
//     },
//   ];

//   const statusOptions = [
//     { value: 'all', label: 'Tous les messages' },
//     { value: 'pending', label: 'En attente' },
//     { value: 'in_progress', label: 'En cours' },
//     { value: 'resolved', label: 'Résolus' }
//   ];

//   const getStatusBadge = (status) => {
//     const badges = {
//       pending: { bg: 'bg-orange-100', text: 'text-orange-700', label: 'En attente', icon: AlertCircle, border: 'border-orange-200' },
//       in_progress: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'En cours', icon: Clock, border: 'border-blue-200' },
//       resolved: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Résolu', icon: CheckCircle2, border: 'border-emerald-200' }
//     };
//     return badges[status] || badges.pending;
//   };

//   const getPriorityBadge = (priority) => {
//     const badges = {
//       high: { bg: 'bg-red-100', text: 'text-red-700', label: 'Haute', border: 'border-red-200' },
//       medium: { bg: 'bg-orange-100', text: 'text-orange-700', label: 'Moyenne', border: 'border-orange-200' },
//       low: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Basse', border: 'border-blue-200' }
//     };
//     return badges[priority] || badges.medium;
//   };

//   const filteredMessages = messages.filter(message => {
//     const matchesSearch = 
//       message.senderName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       message.subject.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       message.pharmacy.toLowerCase().includes(searchTerm.toLowerCase());
//     const matchesStatus = filterStatus === 'all' || message.status === filterStatus;
//     return matchesSearch && matchesStatus;
//   });

//   const stats = {
//     total: messages.length,
//     pending: messages.filter(m => m.status === 'pending').length,
//     inProgress: messages.filter(m => m.status === 'in_progress').length,
//     resolved: messages.filter(m => m.status === 'resolved').length
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', hour: '2-digit', minute: '2-digit' });
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
//       <div className="fixed inset-0 overflow-hidden pointer-events-none opacity-30">
//         <div className="absolute inset-0" style={{
//           backgroundImage: `radial-gradient(circle at 2px 2px, rgb(209, 213, 219) 1px, transparent 0)`,
//           backgroundSize: '40px 40px'
//         }}></div>
//       </div>

//       <main className="relative z-10 p-4 md:p-8">
//         <div className="mb-8">
//           <h1 className="text-4xl md:text-5xl font-black text-gray-800 mb-4">
//             Messages des Pharmaciens
//           </h1>
//           <p className="text-gray-600 text-lg">Gérez les demandes de votre réseau</p>
//         </div>

//         {/* Stats */}
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-8">
//           <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm text-gray-600 mb-1">Total</p>
//                 <p className="text-3xl font-bold text-gray-800">{stats.total}</p>
//               </div>
//               <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center shadow-md">
//                 <MessageSquare className="text-white" size={24} />
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm text-gray-600 mb-1">En attente</p>
//                 <p className="text-3xl font-bold text-orange-600">{stats.pending}</p>
//               </div>
//               <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center shadow-md">
//                 <AlertCircle className="text-white" size={24} />
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm text-gray-600 mb-1">En cours</p>
//                 <p className="text-3xl font-bold text-blue-600">{stats.inProgress}</p>
//               </div>
//               <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-md">
//                 <Clock className="text-white" size={24} />
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm text-gray-600 mb-1">Résolus</p>
//                 <p className="text-3xl font-bold text-emerald-600">{stats.resolved}</p>
//               </div>
//               <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center shadow-md">
//                 <CheckCircle2 className="text-white" size={24} />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Search and Filter */}
//         <div className="bg-white rounded-2xl shadow-lg p-6 mb-8 border border-gray-200">
//           <div className="flex flex-col md:flex-row gap-4">
//             <div className="flex-1">
//               <div className="relative">
//                 <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
//                 <input
//                   type="text"
//                   placeholder="Rechercher..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500"
//                 />
//               </div>
//             </div>
//             <select
//               value={filterStatus}
//               onChange={(e) => setFilterStatus(e.target.value)}
//               className="px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500"
//             >
//               {statusOptions.map(option => (
//                 <option key={option.value} value={option.value}>{option.label}</option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {/* Messages */}
//         <div className="space-y-4">
//           {filteredMessages.map((message) => {
//             const statusBadge = getStatusBadge(message.status);
//             const priorityBadge = getPriorityBadge(message.priority);
//             const StatusIcon = statusBadge.icon;

//             return (
//               <div key={message.id} className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
//                 <div className="flex justify-between items-start gap-4">
//                   <div className="flex-1">
//                     <div className="flex items-center gap-2 mb-2">
//                       <h3 className="font-bold text-gray-800">{message.senderName}</h3>
//                       <span className={`px-2 py-1 ${statusBadge.bg} ${statusBadge.text} rounded-full text-xs font-bold`}>
//                         {statusBadge.label}
//                       </span>
//                       <span className={`px-2 py-1 ${priorityBadge.bg} ${priorityBadge.text} rounded-full text-xs font-bold`}>
//                         {priorityBadge.label}
//                       </span>
//                     </div>
//                     <p className="text-sm text-gray-600 mb-2">{message.pharmacy}</p>
//                     <h4 className="font-semibold text-gray-800 mb-2">{message.subject}</h4>
//                     <p className="text-gray-600 text-sm">{message.message}</p>
//                     <p className="text-xs text-gray-500 mt-2">{formatDate(message.timestamp)}</p>
//                   </div>
//                   <button
//                     onClick={() => {
//                       setSelectedMessage(message);
//                       setShowMessageModal(true);
//                     }}
//                     className="px-4 py-2 bg-emerald-50 text-emerald-600 rounded-xl hover:bg-emerald-100 font-bold"
//                   >
//                     <Eye size={16} className="inline mr-2" />
//                     Voir
//                   </button>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </main>

//       {/* Modal */}
//       {showMessageModal && selectedMessage && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-3xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
//             <div className="bg-gradient-to-r from-emerald-600 to-teal-600 px-6 py-4 flex justify-between items-center rounded-t-3xl">
//               <h2 className="text-2xl font-black text-white">Message de {selectedMessage.senderName}</h2>
//               <button onClick={() => setShowMessageModal(false)} className="text-white hover:bg-white/20 p-2 rounded-xl">
//                 <X size={24} />
//               </button>
//             </div>
//             <div className="p-6">
//               <div className="bg-gray-50 rounded-xl p-4 mb-4">
//                 <p><strong>Pharmacie:</strong> {selectedMessage.pharmacy}</p>
//                 <p><strong>Email:</strong> {selectedMessage.senderEmail}</p>
//                 <p><strong>Téléphone:</strong> {selectedMessage.senderPhone}</p>
//               </div>
//               <h3 className="font-bold mb-2">{selectedMessage.subject}</h3>
//               <p className="text-gray-700 mb-4">{selectedMessage.message}</p>
              
//               {!selectedMessage.replied && (
//                 <div>
//                   <label className="block font-bold mb-2">Votre réponse</label>
//                   <textarea
//                     value={replyText}
//                     onChange={(e) => setReplyText(e.target.value)}
//                     rows={4}
//                     className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-emerald-500"
//                     placeholder="Tapez votre réponse..."
//                   />
//                   <button
//                     onClick={() => {
//                       alert('Réponse envoyée !');
//                       setShowMessageModal(false);
//                     }}
//                     className="mt-4 px-6 py-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white rounded-xl font-bold"
//                   >
//                     <Send size={20} className="inline mr-2" />
//                     Envoyer
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminMessaging;

import React, { useState } from 'react';
import { MessageSquare, Send, Search, Filter, User, Clock, CheckCircle2, AlertCircle, Eye, Trash2, Reply, X, Building2 } from 'lucide-react';

const AdminMessagingSobre = () => {
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterDate, setFilterDate] = useState('');
  const [replyText, setReplyText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const messages = [
    {
      id: 1,
      senderName: 'Dr. Fatou Ndiaye',
      senderEmail: 'f.ndiaye@pharmacie.sn',
      senderPhone: '+221 77 123 45 67',
      pharmacy: 'Pharmacie Dakar Centre',
      subject: 'Problème de connexion au système',
      message: 'Bonjour, depuis ce matin je n\'arrive plus à me connecter à la plateforme. J\'obtiens une erreur "Session expirée" à chaque tentative. Pouvez-vous m\'aider ? Merci.',
      status: 'pending',
      priority: 'high',
      timestamp: '2025-11-16T09:30:00',
      replied: false,
      reply: null
    },
    {
      id: 2,
      senderName: 'Dr. Amadou Diop',
      senderEmail: 'a.diop@pharmacie.sn',
      senderPhone: '+221 77 234 56 78',
      pharmacy: 'Pharmacie Thies Nord',
      subject: 'Demande d\'ajout de pharmacien',
      message: 'Bonjour, j\'ai embauché un nouveau pharmacien, Dr. Mamadou Sall. Pourriez-vous créer son compte sur la plateforme ? Je vous envoie ses informations par email séparé. Merci d\'avance.',
      status: 'in_progress',
      priority: 'medium',
      timestamp: '2025-11-16T08:15:00',
      replied: false,
      reply: null
    },
    {
      id: 3,
      senderName: 'Dr. Aïssa Fall',
      senderEmail: 'a.fall@pharmacie.sn',
      senderPhone: '+221 77 345 67 89',
      pharmacy: 'Pharmacie Mbour',
      subject: 'Question sur le planning de garde',
      message: 'Bonjour, je voulais savoir comment modifier le planning de garde pour la semaine prochaine. Ma pharmacie ne pourra pas assurer la garde mercredi soir à cause de travaux. Merci.',
      status: 'resolved',
      priority: 'low',
      timestamp: '2025-11-15T14:20:00',
      replied: true,
      reply: {
        text: 'Bonjour Dr. Fall, vous pouvez modifier le planning directement depuis votre espace. Allez dans "Planning de garde" > Sélectionnez la semaine > Cliquez sur "Modifier". Si vous avez besoin d\'aide, n\'hésitez pas. Cordialement.',
        timestamp: '2025-11-15T15:00:00',
        repliedBy: 'Dr. Touré (Admin)'
      }
    },
    {
      id: 4,
      senderName: 'Dr. Moussa Sarr',
      senderEmail: 'm.sarr@pharmacie.sn',
      senderPhone: '+221 77 456 78 90',
      pharmacy: 'Pharmacie Saint-Louis',
      subject: 'Mise à jour des horaires',
      message: 'Bonjour, suite à notre discussion téléphonique, je confirme que mes nouveaux horaires sont 7h30 - 21h30 du lundi au samedi. Pourriez-vous mettre à jour sur le système ? Merci beaucoup.',
      status: 'resolved',
      priority: 'low',
      timestamp: '2025-11-15T11:45:00',
      replied: true,
      reply: {
        text: 'Bonjour Dr. Sarr, vos horaires ont bien été mis à jour dans le système. Les patients pourront voir vos nouveaux horaires dès maintenant. Bonne continuation !',
        timestamp: '2025-11-15T12:10:00',
        repliedBy: 'Dr. Touré (Admin)'
      }
    },
    {
      id: 5,
      senderName: 'Dr. Khady Ba',
      senderEmail: 'k.ba@pharmacie.sn',
      senderPhone: '+221 77 567 89 01',
      pharmacy: 'Pharmacie Rufisque',
      subject: 'Formation sur nouvelles fonctionnalités',
      message: 'Bonjour, j\'ai vu qu\'il y a de nouvelles fonctionnalités sur la plateforme. Pourriez-vous organiser une formation pour mon équipe ? Nous sommes 3 pharmaciens. Merci d\'avance.',
      status: 'resolved',
      priority: 'medium',
      timestamp: '2025-11-14T16:30:00',
      replied: true,
      reply: {
        text: 'Bonjour Dr. Ba, avec plaisir ! Je vous propose une session de formation en visioconférence mardi prochain à 14h. Je vous envoie le lien de connexion par email. À bientôt !',
        timestamp: '2025-11-14T17:15:00',
        repliedBy: 'Mariama Diop (Assistante)'
      }
    },
    {
      id: 6,
      senderName: 'Dr. Omar Sow',
      senderEmail: 'o.sow@pharmacie.sn',
      senderPhone: '+221 77 678 90 12',
      pharmacy: 'Pharmacie Kaolack',
      subject: 'Problème d\'impression des ordonnances',
      message: 'Bonjour, depuis la dernière mise à jour, je ne peux plus imprimer les ordonnances. Le bouton d\'impression ne répond pas. Merci de vérifier.',
      status: 'pending',
      priority: 'high',
      timestamp: '2025-11-14T10:20:00',
      replied: false,
      reply: null
    },
    {
      id: 7,
      senderName: 'Dr. Marième Ndao',
      senderEmail: 'm.ndao@pharmacie.sn',
      senderPhone: '+221 77 789 01 23',
      pharmacy: 'Pharmacie Ziguinchor',
      subject: 'Demande de statistiques mensuelles',
      message: 'Bonjour, est-il possible d\'obtenir les statistiques de ventes du mois dernier ? J\'en ai besoin pour mon rapport trimestriel. Merci.',
      status: 'in_progress',
      priority: 'medium',
      timestamp: '2025-11-13T15:45:00',
      replied: false,
      reply: null
    },
    {
      id: 8,
      senderName: 'Dr. Ibrahima Gueye',
      senderEmail: 'i.gueye@pharmacie.sn',
      senderPhone: '+221 77 890 12 34',
      pharmacy: 'Pharmacie Louga',
      subject: 'Erreur dans le calcul des stocks',
      message: 'Bonjour, j\'ai remarqué que le système affiche des stocks négatifs pour certains médicaments alors que j\'en ai en réserve. Comment corriger cela ?',
      status: 'resolved',
      priority: 'medium',
      timestamp: '2025-11-13T09:30:00',
      replied: true,
      reply: {
        text: 'Bonjour Dr. Gueye, cette erreur a été corrigée. Les stocks ont été réinitialisés. Veuillez vérifier et me confirmer si tout est correct maintenant.',
        timestamp: '2025-11-13T10:15:00',
        repliedBy: 'Dr. Touré (Admin)'
      }
    },
    {
      id: 9,
      senderName: 'Dr. Awa Diallo',
      senderEmail: 'a.diallo@pharmacie.sn',
      senderPhone: '+221 77 901 23 45',
      pharmacy: 'Pharmacie Diourbel',
      subject: 'Question sur les paiements en ligne',
      message: 'Bonjour, comment puis-je activer les paiements par carte bancaire sur ma pharmacie ? Est-ce que c\'est inclus dans l\'abonnement ?',
      status: 'pending',
      priority: 'low',
      timestamp: '2025-11-12T14:00:00',
      replied: false,
      reply: null
    },
    {
      id: 10,
      senderName: 'Dr. Cheikh Sy',
      senderEmail: 'c.sy@pharmacie.sn',
      senderPhone: '+221 77 012 34 56',
      pharmacy: 'Pharmacie Tambacounda',
      subject: 'Récupération de mot de passe',
      message: 'Bonjour, un de mes employés a oublié son mot de passe et le lien de récupération ne fonctionne pas. Pouvez-vous réinitialiser son compte ?',
      status: 'resolved',
      priority: 'medium',
      timestamp: '2025-11-12T11:20:00',
      replied: true,
      reply: {
        text: 'Bonjour Dr. Sy, le mot de passe a été réinitialisé. Votre employé recevra un email avec les nouvelles instructions de connexion.',
        timestamp: '2025-11-12T11:45:00',
        repliedBy: 'Mariama Diop (Assistante)'
      }
    },
    {
      id: 11,
      senderName: 'Dr. Binta Kane',
      senderEmail: 'b.kane@pharmacie.sn',
      senderPhone: '+221 77 123 45 00',
      pharmacy: 'Pharmacie Kolda',
      subject: 'Suggestion d\'amélioration',
      message: 'Bonjour, serait-il possible d\'ajouter une fonctionnalité de gestion des périmés ? Ce serait vraiment utile pour nous. Merci de considérer cette demande.',
      status: 'in_progress',
      priority: 'low',
      timestamp: '2025-11-11T16:30:00',
      replied: false,
      reply: null
    },
    {
      id: 12,
      senderName: 'Dr. Abdoulaye Mbaye',
      senderEmail: 'a.mbaye@pharmacie.sn',
      senderPhone: '+221 77 234 56 01',
      pharmacy: 'Pharmacie Matam',
      subject: 'Problème de synchronisation',
      message: 'Bonjour, les données ne se synchronisent pas entre mes deux ordinateurs. J\'ai essayé de me déconnecter et reconnecter mais le problème persiste.',
      status: 'pending',
      priority: 'high',
      timestamp: '2025-11-11T08:50:00',
      replied: false,
      reply: null
    },
    {
      id: 13,
      senderName: 'Dr. Coumba Thiam',
      senderEmail: 'c.thiam@pharmacie.sn',
      senderPhone: '+221 77 345 67 02',
      pharmacy: 'Pharmacie Kaffrine',
      subject: 'Demande de formation en ligne',
      message: 'Bonjour, proposez-vous des formations en ligne pour maîtriser toutes les fonctionnalités de la plateforme ? Si oui, comment puis-je m\'inscrire ?',
      status: 'resolved',
      priority: 'low',
      timestamp: '2025-11-10T13:15:00',
      replied: true,
      reply: {
        text: 'Bonjour Dr. Thiam, oui nous proposons des formations en ligne tous les jeudis à 15h. Je vous envoie le lien d\'inscription par email.',
        timestamp: '2025-11-10T14:00:00',
        repliedBy: 'Mariama Diop (Assistante)'
      }
    },
    {
      id: 14,
      senderName: 'Dr. Malick Diouf',
      senderEmail: 'm.diouf@pharmacie.sn',
      senderPhone: '+221 77 456 78 03',
      pharmacy: 'Pharmacie Kédougou',
      subject: 'Erreur lors de la facturation',
      message: 'Bonjour, j\'ai une erreur "Code TVA invalide" quand j\'essaie de créer une facture. Pourtant mes paramètres sont corrects. Que faire ?',
      status: 'in_progress',
      priority: 'high',
      timestamp: '2025-11-10T10:30:00',
      replied: false,
      reply: null
    },
    {
      id: 15,
      senderName: 'Dr. Yacine Cissé',
      senderEmail: 'y.cisse@pharmacie.sn',
      senderPhone: '+221 77 567 89 04',
      pharmacy: 'Pharmacie Sédhiou',
      subject: 'Demande d\'exportation de données',
      message: 'Bonjour, comment puis-je exporter toutes mes données de ventes de l\'année 2024 ? J\'en ai besoin pour mon comptable. Merci.',
      status: 'resolved',
      priority: 'medium',
      timestamp: '2025-11-09T17:00:00',
      replied: true,
      reply: {
        text: 'Bonjour Dr. Cissé, vous pouvez exporter vos données depuis le menu Rapports > Exporter > Sélectionnez la période. Le fichier sera au format Excel.',
        timestamp: '2025-11-09T17:30:00',
        repliedBy: 'Dr. Touré (Admin)'
      }
    },
  ];

  const statusOptions = [
    { value: 'all', label: 'Tous les messages' },
    { value: 'pending', label: 'En attente' },
    { value: 'in_progress', label: 'En cours' },
    { value: 'resolved', label: 'Résolus' }
  ];

  const getStatusBadge = (status) => {
    const badges = {
      pending: { bg: 'bg-orange-100', text: 'text-orange-700', label: 'En attente', icon: AlertCircle, border: 'border-orange-200' },
      in_progress: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'En cours', icon: Clock, border: 'border-blue-200' },
      resolved: { bg: 'bg-green-100', text: 'text-green-700', label: 'Résolu', icon: CheckCircle2, border: 'border-green-200' }
    };
    return badges[status] || badges.pending;
  };

  const getPriorityBadge = (priority) => {
    const badges = {
      high: { bg: 'bg-red-100', text: 'text-red-700', label: 'Haute', border: 'border-red-200' },
      medium: { bg: 'bg-orange-100', text: 'text-orange-700', label: 'Moyenne', border: 'border-orange-200' },
      low: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Basse', border: 'border-blue-200' }
    };
    return badges[priority] || badges.medium;
  };

  const filteredMessages = messages.filter(message => {
    const matchesSearch = 
      message.senderName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      message.subject.toLowerCase().includes(searchTerm.toLowerCase()) ||
      message.pharmacy.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'all' || message.status === filterStatus;
    
    // Filter by date
    const matchesDate = !filterDate || message.timestamp.startsWith(filterDate);
    
    return matchesSearch && matchesStatus && matchesDate;
  });

  // Pagination
  const totalPages = Math.ceil(filteredMessages.length / itemsPerPage);
  const paginatedMessages = filteredMessages.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const stats = {
    total: messages.length,
    pending: messages.filter(m => m.status === 'pending').length,
    inProgress: messages.filter(m => m.status === 'in_progress').length,
    resolved: messages.filter(m => m.status === 'resolved').length
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = (now - date) / (1000 * 60 * 60);

    if (diffInHours < 1) {
      return 'Il y a quelques minutes';
    } else if (diffInHours < 24) {
      return `Il y a ${Math.floor(diffInHours)}h`;
    } else {
      return date.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="p-6">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6 border border-gray-200">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
              <MessageSquare className="text-white" size={24} />
            </div>
            
            <div className="flex-1">
              <h1 className="text-2xl font-bold text-gray-900">Messages des Pharmaciens</h1>
              <p className="text-gray-600 text-sm">Gérez les demandes de votre réseau</p>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Total</p>
                <p className="text-3xl font-bold text-gray-900">{stats.total}</p>
              </div>
              <div className="w-12 h-12 bg-gray-600 rounded-lg flex items-center justify-center">
                <MessageSquare className="text-white" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">En attente</p>
                <p className="text-3xl font-bold text-orange-600">{stats.pending}</p>
              </div>
              <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center">
                <AlertCircle className="text-white" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">En cours</p>
                <p className="text-3xl font-bold text-blue-600">{stats.inProgress}</p>
              </div>
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                <Clock className="text-white" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Résolus</p>
                <p className="text-3xl font-bold text-green-600">{stats.resolved}</p>
              </div>
              <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                <CheckCircle2 className="text-white" size={24} />
              </div>
            </div>
          </div>
        </div>

        {/* Search and Filter */}
        <div className="bg-white rounded-lg shadow-sm p-4 mb-6 border border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
            <div className="md:col-span-2">
              <div className="relative">
                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <input
                  type="text"
                  placeholder="Rechercher..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-12 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>
            </div>
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
            >
              {statusOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            <input
              type="date"
              value={filterDate}
              onChange={(e) => {
                setFilterDate(e.target.value);
                setCurrentPage(1);
              }}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="Filtrer par date"
            />
          </div>
        </div>

        {/* Messages List */}
        <div className="space-y-4">
          {paginatedMessages.map((message) => {
            const statusBadge = getStatusBadge(message.status);
            const priorityBadge = getPriorityBadge(message.priority);
            const StatusIcon = statusBadge.icon;

            return (
              <div key={message.id} className="bg-white rounded-lg shadow-sm border border-gray-200">
                <div className="p-4">
                  <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
                    <div className="flex-1">
                      <div className="flex items-start space-x-3">
                        <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center flex-shrink-0">
                          <User className="text-white" size={20} />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex flex-wrap items-center gap-2 mb-2">
                            <h3 className="font-bold text-gray-900">{message.senderName}</h3>
                            <span className={`px-2 py-0.5 ${statusBadge.bg} ${statusBadge.text} rounded text-xs font-medium border ${statusBadge.border}`}>
                              <StatusIcon size={12} className="mr-1 inline" />
                              {statusBadge.label}
                            </span>
                            <span className={`px-2 py-0.5 ${priorityBadge.bg} ${priorityBadge.text} rounded text-xs font-medium border ${priorityBadge.border}`}>
                              {priorityBadge.label}
                            </span>
                          </div>
                          
                          <div className="flex flex-wrap items-center gap-3 text-xs text-gray-600 mb-2">
                            <span className="flex items-center">
                              <Building2 size={12} className="mr-1" />
                              {message.pharmacy}
                            </span>
                            <span className="flex items-center">
                              <Clock size={12} className="mr-1" />
                              {formatDate(message.timestamp)}
                            </span>
                          </div>

                          <h4 className="font-semibold text-gray-900 text-sm mb-2">{message.subject}</h4>
                          <p className="text-gray-600 text-sm leading-relaxed">{message.message}</p>
                        </div>
                      </div>
                    </div>

                    <div className="flex md:flex-col gap-2">
                      <button
                        onClick={() => {
                          setSelectedMessage(message);
                          setReplyText('');
                          setShowMessageModal(true);
                        }}
                        className="flex-1 md:flex-none px-3 py-2 bg-green-50 text-green-600 rounded-lg hover:bg-green-100 transition-all font-medium text-sm flex items-center justify-center border border-green-200"
                      >
                        {message.replied ? (
                          <>
                            <Eye size={14} className="mr-2" />
                            Voir
                          </>
                        ) : (
                          <>
                            <Reply size={14} className="mr-2" />
                            Répondre
                          </>
                        )}
                      </button>
                      <button
                        onClick={() => {
                          if (window.confirm('Supprimer ce message ?')) {
                            alert('Message supprimé');
                          }
                        }}
                        className="px-3 py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-all border border-red-200"
                      >
                        <Trash2 size={14} />
                      </button>
                    </div>
                  </div>

                  {/* Reply Display */}
                  {message.replied && message.reply && (
                    <div className="mt-4 pt-4 border-t border-gray-200">
                      <div className="bg-green-50 rounded-lg p-3 border-l-4 border-green-600">
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-green-600 rounded-lg flex items-center justify-center flex-shrink-0">
                            <Reply className="text-white" size={16} />
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center justify-between mb-2">
                              <p className="text-xs font-bold text-green-800 flex items-center">
                                <User size={12} className="mr-1" />
                                Réponse de {message.reply.repliedBy}
                              </p>
                              <span className="text-xs text-gray-600 flex items-center">
                                <Clock size={10} className="mr-1" />
                                {formatDate(message.reply.timestamp)}
                              </span>
                            </div>
                            <p className="text-sm text-gray-700 leading-relaxed">{message.reply.text}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="mt-6 bg-white rounded-lg shadow-sm p-4 border border-gray-200">
            <div className="flex items-center justify-between">
              <div className="text-sm text-gray-600">
                Affichage de {((currentPage - 1) * itemsPerPage) + 1} à{' '}
                {Math.min(currentPage * itemsPerPage, filteredMessages.length)} sur{' '}
                {filteredMessages.length} messages
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all text-sm font-medium"
                >
                  Précédent
                </button>
                
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => setCurrentPage(i + 1)}
                    className={`px-4 py-2 rounded-lg font-medium transition-all text-sm ${
                      currentPage === i + 1
                        ? 'bg-green-600 text-white'
                        : 'border border-gray-300 hover:bg-gray-100'
                    }`}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                  className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all text-sm font-medium"
                >
                  Suivant
                </button>
              </div>
            </div>
          </div>
        )}

        {filteredMessages.length === 0 && (
          <div className="text-center py-12 bg-white rounded-lg shadow-sm border border-gray-200">
            <MessageSquare size={48} className="mx-auto text-gray-300 mb-4" />
            <p className="text-gray-500">Aucun message trouvé</p>
          </div>
        )}
      </main>

      {/* Modal */}
      {showMessageModal && selectedMessage && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-green-600 px-6 py-4 flex justify-between items-center">
              <h2 className="text-xl font-bold text-white">Message de {selectedMessage.senderName}</h2>
              <button onClick={() => setShowMessageModal(false)} className="text-white hover:bg-green-700 p-2 rounded-lg transition-all">
                <X size={24} />
              </button>
            </div>
            
            <div className="p-6">
              {/* Sender Info */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6 border border-gray-200">
                <h3 className="font-bold text-gray-900 mb-3 flex items-center">
                  <User size={18} className="mr-2" />
                  Informations du pharmacien
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                  <div>
                    <span className="text-gray-600">Nom:</span>
                    <span className="ml-2 font-semibold text-gray-900">{selectedMessage.senderName}</span>
                  </div>
                  <div>
                    <span className="text-gray-600">Pharmacie:</span>
                    <span className="ml-2 font-semibold text-gray-900">{selectedMessage.pharmacy}</span>
                  </div>
                  <div>
                    <span className="text-gray-600">Email:</span>
                    <a href={`mailto:${selectedMessage.senderEmail}`} className="ml-2 text-green-600 hover:underline">
                      {selectedMessage.senderEmail}
                    </a>
                  </div>
                  <div>
                    <span className="text-gray-600">Téléphone:</span>
                    <a href={`tel:${selectedMessage.senderPhone}`} className="ml-2 text-green-600 hover:underline">
                      {selectedMessage.senderPhone}
                    </a>
                  </div>
                </div>
              </div>

              {/* Message Content */}
              <div className="mb-6">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-bold text-gray-900">{selectedMessage.subject}</h3>
                  <span className="text-sm text-gray-500">{formatDate(selectedMessage.timestamp)}</span>
                </div>
                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <p className="text-gray-700 leading-relaxed text-sm">{selectedMessage.message}</p>
                </div>
              </div>

              {/* Existing Reply */}
              {selectedMessage.replied && selectedMessage.reply && (
                <div className="mb-6">
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center">
                    <CheckCircle2 size={18} className="mr-2 text-green-600" />
                    Réponse envoyée
                  </h3>
                  <div className="bg-green-50 rounded-lg p-4 border border-green-200">
                    <p className="text-xs font-semibold text-green-800 mb-2">
                      Par {selectedMessage.reply.repliedBy} • {formatDate(selectedMessage.reply.timestamp)}
                    </p>
                    <p className="text-gray-700 leading-relaxed text-sm">{selectedMessage.reply.text}</p>
                  </div>
                </div>
              )}

              {/* Reply Form */}
              {!selectedMessage.replied && (
                <div>
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center">
                    <Reply size={18} className="mr-2" />
                    Votre réponse
                  </h3>
                  <textarea
                    value={replyText}
                    onChange={(e) => setReplyText(e.target.value)}
                    rows={5}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 resize-none text-sm"
                    placeholder="Tapez votre réponse ici..."
                  />
                </div>
              )}

              {/* Actions */}
              <div className="flex space-x-3 pt-6 border-t border-gray-200 mt-6">
                <button
                  onClick={() => setShowMessageModal(false)}
                  className="flex-1 px-6 py-3 bg-gray-100 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-200 transition-all font-medium"
                >
                  Fermer
                </button>
                {!selectedMessage.replied && (
                  <button
                    onClick={() => {
                      alert('Réponse envoyée !');
                      setShowMessageModal(false);
                    }}
                    className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all font-medium"
                  >
                    <Send size={18} className="inline mr-2" />
                    Envoyer
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminMessagingSobre;